import { Close } from "backpack-ui/dist/components/icon";
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var SearchInputCancelButton = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React.createElement("button", { className: cn(styles.searchInputCancelButton, className), onClick: onClick, type: "reset" },
        React.createElement(Close, { width: 24, height: 24 })));
};
export default SearchInputCancelButton;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/searchInputCancelButton/index.tsx
// module id = 01s7
// module chunks = 2